import React from 'react';

export const Retry = ({ customStyles }: { customStyles?: string }) => {
	return (
		<svg
			className={customStyles}
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			fill="none"
			viewBox="0 0 24 24"
		>
			<mask
				id="mask0_61968_341"
				style={{ maskType: 'alpha' }}
				width="16"
				height="17"
				x="4"
				y="4"
				maskUnits="userSpaceOnUse"
			>
				<path
					fill="#008635"
					d="M17.66 15.941a.653.653 0 01.527-.316c.422 0 .704.457.457.844-1.37 2.215-3.867 3.656-6.644 3.656a7.862 7.862 0 01-7.875-7.875c0-4.324 3.516-7.875 7.875-7.875a7.79 7.79 0 015.133 1.934l1.09-1.09a.96.96 0 01.668-.282c.527 0 .984.458.984.985v3.516a.578.578 0 01-.563.562h-3.55a.945.945 0 01-.95-.95c0-.245.07-.491.282-.667l1.265-1.266C15.164 6.133 13.652 5.5 12 5.5a6.752 6.752 0 00-6.75 6.75A6.752 6.752 0 0012 19a6.792 6.792 0 005.66-3.059zm1.09-9.632l-2.602 2.566h2.602V6.309z"
				></path>
			</mask>
			<g mask="url(#mask0_61968_341)">
				<path fill="#008635" d="M0 0H24V24H0z"></path>
			</g>
		</svg>
	);
};
